import { Component, Input, inject, SecurityContext, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { makeStateKey, TransferState } from '@angular/core';
import { CommonModule } from '@angular/common';
import { isPlatformServer } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';

const getDynamicContentKey = (id: string) => makeStateKey<string>(`dynamic-content-${id}`);

@Component({
  selector: 'app-dynamic-content',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div [innerHTML]="sanitizedContent"></div>
  `
})
export class DynamicContentComponent implements OnInit {
  @Input() contentId!: string;
  @Input() set htmlContent(value: string) {
    this.processContent(value);
  }

  private sanitizer = inject(DomSanitizer);
  private transferState = inject(TransferState);
  private platformId = inject(PLATFORM_ID);
  
  sanitizedContent: SafeHtml | null = null;

  ngOnInit() {
  //   // Check if content exists in TransferState on client-side
    if (!isPlatformServer(this.platformId)) {
      const stateKey = getDynamicContentKey(this.contentId);
      if (this.transferState && this.transferState.hasKey(stateKey)) {
        const savedContent = this.transferState.get(stateKey, '');
        this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(savedContent);
        this.transferState.remove(stateKey);
      }
    }
  }

  private processContent(content: string) {
    if (!content || content === "") return;

    const stateKey = getDynamicContentKey(this.contentId);
    
    // const sanitizedContent = this.sanitizer.sanitize(SecurityContext.HTML, content);
    // const sanitizeContent = this.sanitizer.bypassSecurityTrustHtml(content);
  
    // if (sanitizeContent) {
      // Store in TransferState only during SSR
    if (isPlatformServer(this.platformId)) {
      this.transferState.set(stateKey, content);
    }

    this.sanitizedContent = this.sanitizer.bypassSecurityTrustHtml(content);
  }
}